import { notification } from "antd"
import Breadcrumbs from "components/Common/Breadcrumb"
import ConfigUrl, { axiosbaseurl } from "../../config"
import React, { useEffect, useState } from "react"
import { SiTicktick } from "react-icons/si"
import { useNavigate } from "react-router-dom"
import { Container, Label } from "reactstrap"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"
import { FaChevronLeft, FaSave, FaUser } from "react-icons/fa"
import dummyStocks from "constants/Stocks"
import { MdAdd } from "react-icons/md"
import { IoMdWarning } from "react-icons/io"
import Loader from "pages/Loader"
import moment from "moment"
import WindowedSelect from "react-windowed-select"

const AddPortfolio = () => {
  document.title = "Portfolio | Return First Investments"

  const { checkAccess } = usePermissionData()
  const navigate = useNavigate()

  const [Customers, setCustomers] = useState([])
  const [Stocksdata, setStocksdata] = useState([])

  useEffect(() => {
    getData()
    getStocks()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`customer-management`)
      if (response?.data?.success) {
        setCustomers(response?.data?.data)
      }
    } catch (e) {
      console.log("Error", e.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  async function getStocks() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`stocks/list`)
      if (response?.data?.success) {
        setStocksdata(
          response.data.data.map(item => {
            return { value: item.Symbol, label: item.Name }
          })
        )
      }
    } catch (e) {
      console.log("Error", e.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  const [CustomerId, setCustomerId] = useState("")
  const [Loading, setLoading] = useState(false)
  // Stocks state
  const [stocks, setStocks] = useState([
    {
      Name: "",
      Symbol: "",
      PurchaseQty: "",
      PurchaseAmount: "",
      PurchaseDate: "",
      SellQty: "",
      SellDate: "",
      SellAmount: "",
    },
  ])

  // Error state
  const [errors, setErrors] = useState({})

  // Handle stock field change
  const handleStockChange = (index, field, value) => {
    const updatedStocks = [...stocks]
    updatedStocks[index][field] = value
    setStocks(updatedStocks)
  }

  // Add stock row
  const addStock = () => {
    setStocks([
      ...stocks,
      {
        Name: "",
        Symbol: "",
        PurchaseQty: "",
        PurchaseAmount: "",
        PurchaseDate: "",
        SellQty: "",
        SellDate: "",
        SellAmount: "",
      },
    ])
  }

  // Remove stock row
  const removeStock = index => {
    if (stocks.length > 1) {
      setStocks(stocks.filter((_, i) => i !== index))
    } else {
      setStocks([
        {
          Name: "",
          Symbol: "",
          PurchaseQty: "",
          PurchaseAmount: "",
          PurchaseDate: "",
          SellQty: "",
          SellDate: "",
          SellAmount: "",
        },
      ])
    }
  }

  // Calculate dynamic portfolio value and total stocks
  const calculatePortfolioValue = () => {
    return stocks
      .reduce((total, stock) => {
        const qty = parseFloat(stock.PurchaseQty) || 0
        const buyPrice = parseFloat(stock.PurchaseAmount) || 0
        return total + buyPrice
      }, 0)
      .toFixed(2)
  }

  const calculateTotalStocks = () => {
    return stocks.reduce((total, stock) => {
      const bought = parseFloat(stock.PurchaseQty) || 0
      const sold = parseFloat(stock.SellQty) || 0
      return total + Math.max(bought - sold, 0)
    }, 0)
  }

  // Validate form
  const validateForm = () => {
    let newErrors = {}
    let isValid = true

    let stockErrors = stocks.map(stock => ({
      Name: stock.Name.trim() ? "" : "Stock Name is required",
      PurchaseQty:
        stock.PurchaseQty && !isNaN(stock.PurchaseQty)
          ? ""
          : "Qty must be a number",
      PurchaseAmount:
        stock.PurchaseAmount && !isNaN(stock.PurchaseAmount)
          ? ""
          : "Buy Price must be a number",
      PurchaseDate: stock.PurchaseDate ? "" : "Purchase Date is required",
    }))

    if (stockErrors.some(stock => Object.values(stock).some(error => error))) {
      newErrors.stocks = stockErrors
      isValid = false
    }

    if (!CustomerId) {
      newErrors.CustomerId = "Customer selection is required"
      isValid = false
    }
    setErrors(newErrors)
    return isValid
  }

  // Handle form submission
  const handleSubmit = async () => {
    if (validateForm()) {
      try {
        setLoading(true)

        const formData = new FormData()
        formData.append("customerId", CustomerId)
        formData.append("portfolioValue", calculatePortfolioValue())
        formData.append("stockDetails", JSON.stringify(stocks))

        const response = await axiosbaseurl.post(`portfolio`, {
          customerId: CustomerId,
          portfolioValue: calculatePortfolioValue(),
          stockDetails: JSON.stringify(stocks),
        })

        if (response?.data?.success) {
          setLoading(false)
          notification.open({
            message: (
              <div className="d-flex align-items-center">
                <div className="pr-20">
                  <SiTicktick className="text-success fs-4 me-2" />
                </div>
                <div className="succes-message">
                  Portfolio Created Successfully.
                </div>
              </div>
            ),
            placement: "topRight",
          })

          setTimeout(() => {
            navigate(`${ConfigUrl.appurl}portfolio`)
          }, 1000)
        } else {
          setLoading(false)
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-10">
                  <IoMdWarning className="text-danger" size={22} />
                </div>
                <div>Opps! Something went wrong.</div>
              </div>
            ),
          })
        }
      } catch (e) {
        setLoading(false)
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
          description: e?.response?.data?.message,
        })
      }
    }
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(1, 2)}>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Portfolio" breadcrumbItem="Add Portfolio" />

            <div className="card p-3">
              <div className="d-flex flex-column flex-xl-row justify-content-between align-items-center mb-2">
                <div className="position-relative add-portfolio-customer-responsive">
                  <Label className="text-muted ps-1 fs-6 fw-medium">
                    Customer <span className="text-danger">*</span>
                  </Label>
                  <select
                    className="form-control w-100 pe-5"
                    placeholder="Select Customer"
                    name="Customer"
                    value={CustomerId}
                    onChange={e => setCustomerId(e.target.value)}
                  >
                    <option value={0}>Select Customer</option>
                    {Customers?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.customerName}
                      </option>
                    ))}
                  </select>
                  <FaUser className="me-2 position-absolute User-ICON" />
                  {errors.CustomerId && (
                    <span className="text-danger">{errors.CustomerId}</span>
                  )}
                </div>
                <div className="text-end mt-3 mt-xl-0 add-portfolio-action-buttons ">
                  <button
                    className="btn edit-Button bg-success text-white me-3 rounded-5"
                    onClick={handleSubmit}
                  >
                    <FaSave className="me-2" />
                    Submit
                  </button>
                  <button
                    className="btn delete-Button rounded-5"
                    onClick={() => navigate(-1)}
                  >
                    <FaChevronLeft className="me-2" />
                    Back
                  </button>
                </div>
              </div>
              <div className="Line" />

              {/* Portfolio Details */}
              <div className="row">
                <div className="form-group col-xl-6 mt-3 bg-light p-3 fw-bold">
                  Current Portfolio Value <br />
                  <span className="fs-2 text-brand-green">
                    ₹ {calculatePortfolioValue()}
                  </span>
                </div>
                <div className="form-group col-xl-6 mt-3 bg-light p-3 fw-bold text-end">
                  Total Stocks Quantity
                  <br />
                  <span className="fs-2 text-warning">
                    {calculateTotalStocks()}
                  </span>
                </div>
              </div>

              {/* Stock Details */}
              <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                <h5>Stock Details</h5>
                <button className="btn Add-Button" onClick={addStock}>
                  <MdAdd className="me-1" />
                  Add Stock
                </button>
              </div>

              {stocks.map((stock, index) => (
                <div
                  key={index}
                  className="row Stocks-Inputs align-items-center mb-3"
                >
                  <div className="form-group col-xl-3 mb-2">
                    <label className="ps-1">
                      Stock <span className="text-danger">*</span>
                    </label>
                    <WindowedSelect
                      options={Stocksdata}
                      value={Stocksdata.find(opt => opt.value === stock.Name)}
                      onChange={selected => {
                        const selectedStock = Stocksdata.find(
                          item => item.value === selected.value
                        )
                        handleStockChange(index, "Name", selected.value)
                        handleStockChange(
                          index,
                          "Symbol",
                          selectedStock?.label || ""
                        )
                      }}
                      placeholder="Select Stock"
                      isSearchable
                      classNamePrefix="react-select"
                      styles={{
                        menu: base => ({ ...base, zIndex: 9999 }), // Ensures dropdown is not cut off
                      }}
                    />
                    {errors.stocks && errors.stocks[index]?.Name && (
                      <span className="text-danger">
                        {errors.stocks[index].Name}
                      </span>
                    )}
                  </div>

                  <div className="form-group col-xl-2 mb-2">
                    <label className="ps-1">
                      Buy Qty <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control ps-3"
                      placeholder="Enter Buy Qty"
                      value={stock.PurchaseQty}
                      onKeyPress={e => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault()
                        }
                      }}
                      onChange={e =>
                        handleStockChange(index, "PurchaseQty", e.target.value)
                      }
                    />
                    {errors.stocks && errors.stocks[index]?.PurchaseQty && (
                      <span className="text-danger">
                        {errors.stocks[index].PurchaseQty}
                      </span>
                    )}
                  </div>

                  <div className="form-group col-xl-3 mb-2">
                    <label className="ps-1">
                      Buy Price (₹) <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      onKeyPress={e => {
                        const allowedKeys = [
                          "0",
                          "1",
                          "2",
                          "3",
                          "4",
                          "5",
                          "6",
                          "7",
                          "8",
                          "9",
                          ".",
                        ]

                        // Prevent multiple decimal points
                        if (
                          !allowedKeys.includes(e.key) ||
                          (e.key === "." && e.currentTarget.value.includes("."))
                        ) {
                          e.preventDefault()
                        }
                      }}
                      className="form-control ps-3"
                      placeholder="Enter Buy Price"
                      value={stock.PurchaseAmount}
                      onChange={e =>
                        handleStockChange(
                          index,
                          "PurchaseAmount",
                          e.target.value
                        )
                      }
                    />
                    {errors.stocks && errors.stocks[index]?.PurchaseAmount && (
                      <span className="text-danger">
                        {errors.stocks[index].PurchaseAmount}
                      </span>
                    )}
                  </div>

                  <div className="form-group col-xl-3 mb-2">
                    <label className="ps-1">
                      Buy Date <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className="form-control ps-3"
                      placeholder="Enter Buy Price"
                      value={moment(stock.PurchaseDate, "DD/MM/YYYY").format(
                        "YYYY-MM-DD"
                      )}
                      onChange={e =>
                        handleStockChange(
                          index,
                          "PurchaseDate",
                          moment(e.target.value).format("DD/MM/YYYY")
                        )
                      }
                    />
                    {errors.stocks && errors.stocks[index]?.PurchaseDate && (
                      <span className="text-danger">
                        {errors.stocks[index].PurchaseDate}
                      </span>
                    )}
                  </div>

                  <div className="form-group col-xl-3">
                    <label className="ps-1">
                      Symbol <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control ps-3"
                      value={stock.Name}
                      disabled
                    />
                  </div>

                  <div className="form-group col-xl-2 mb-2">
                    <label className="ps-1">Sell Qty</label>
                    <input
                      type="text"
                      onKeyPress={e => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault()
                        }
                      }}
                      className="form-control ps-3"
                      placeholder="Enter sell Qty"
                      value={stock.SellQty}
                      onChange={e =>
                        handleStockChange(index, "SellQty", e.target.value)
                      }
                    />
                    {errors.stocks && errors.stocks[index]?.SellQty && (
                      <span className="text-danger">
                        {errors.stocks[index].SellQty}
                      </span>
                    )}
                  </div>

                  <div className="form-group col-xl-3 mb-2">
                    <label className="ps-1">Sell Price</label>
                    <input
                      type="text"
                      onKeyPress={e => {
                        const allowedKeys = [
                          "0",
                          "1",
                          "2",
                          "3",
                          "4",
                          "5",
                          "6",
                          "7",
                          "8",
                          "9",
                          ".",
                        ]

                        // Prevent multiple decimal points
                        if (
                          !allowedKeys.includes(e.key) ||
                          (e.key === "." && e.currentTarget.value.includes("."))
                        ) {
                          e.preventDefault()
                        }
                      }}
                      className="form-control ps-3"
                      placeholder="Enter sell Price"
                      value={stock.SellAmount}
                      onChange={e =>
                        handleStockChange(index, "SellAmount", e.target.value)
                      }
                    />
                    {errors.stocks && errors.stocks[index]?.SellAmount && (
                      <span className="text-danger">
                        {errors.stocks[index].SellAmount}
                      </span>
                    )}
                  </div>
                  <div className="form-group col-xl-3 mb-2">
                    <label className="ps-1">Sell Date</label>
                    <input
                      type="date"
                      className="form-control ps-3"
                      placeholder="Enter sell Date"
                      value={moment(stock.SellDate, "DD/MM/YYYY").format(
                        "YYYY-MM-DD"
                      )}
                      onChange={e =>
                        handleStockChange(
                          index,
                          "SellDate",
                          moment(e.target.value).format("DD/MM/YYYY")
                        )
                      }
                    />
                    {errors.stocks && errors.stocks[index]?.SellDate && (
                      <span className="text-danger">
                        {errors.stocks[index].SellDate}
                      </span>
                    )}
                  </div>

                  <div className="col-xl-1 text-start px-0">
                    <button
                      className="btn delete-Button mt-3"
                      onClick={() => removeStock(index)}
                    >
                      Discard
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </Container>
        </div>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default AddPortfolio
